import React from 'react';
import { useLens } from './LensProvider';
import './Temporal.css';

const pressureColor = (pressure, residue) => {
  // Map pressure to theme-appropriate colors
  // Low pressure: accent blue. Mid: warm amber. High: soft coral.
  if (pressure < 0.2) return `rgba(99, 179, 237, ${0.3 + pressure})`;
  if (pressure < 0.5) return `rgba(246, 173, 85, ${0.3 + pressure * 0.5})`;
  if (pressure < 0.8) return `rgba(237, 137, 99, ${0.4 + pressure * 0.3})`;
  return `rgba(199, 120, 140, ${0.5 + Math.min(residue * 0.3, 0.4)})`;
};

const TemporalRibbon = () => {
  const { experienceHistory } = useLens();

  if (experienceHistory.length === 0) {
    return (
      <div className="temporal-container">
        <h4>Temporal Ribbon</h4>
        <p>Your trajectory through the field will appear here as time passes.</p>
      </div>
    );
  }

  return (
    <div className="temporal-container">
      <h4>Temporal Ribbon</h4>
      <p style={{ fontSize: '0.75rem', color: 'var(--text-dim)', margin: '0 0 8px' }}>
        Like a tree carved into the block — your path through the field over time.
      </p>
      <div className="temporal-ribbon-container">
        {experienceHistory.map((entry, index) => (
          <div
            key={index}
            className="temporal-ribbon-entry"
            style={{
              height: `${Math.max(8, Math.min(1, entry.pressure) * 100)}%`,
              backgroundColor: pressureColor(entry.pressure, entry.residue),
            }}
            title={`Pressure: ${entry.pressure.toFixed(2)}`}
          />
        ))}
      </div>
    </div>
  );
};

export default TemporalRibbon;
